import DropdownMixin from './mixins/dropdown.vue';
import { Slider } from 'foundation-sites/js/foundation.slider';
import $ from 'jquery';

export default {
    name: 'Range',
    template: '#realty-search-range',
    mixins: [DropdownMixin],
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
        values: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
        name: {
            type: String,
            required: true,
        },
        idStub: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
        },
        unit: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            dirty: false,
            min: 0,
            max: 0,
        };
    },
    computed: {
        hasValue() {
            /* eslint-disable-next-line eqeqeq */
            return this.value && (this.value.min != this.values.min || this.value.max != this.values.max);
        },
        screenValue() {
            if (this.hasValue) {
                let screenValue = `${Number(this.value.min).toLocaleString()} - ${Number(
                    this.value.max,
                ).toLocaleString()}`;

                if (this.unit) {
                    screenValue += this.unit;
                }

                return screenValue;
            }

            return this.dirty ? 'egal' : this.placeholder;
        },
    },
    slider: null,
    methods: {
        clearValue() {
            this.dirty = true;
            this.$emit('input', this.values);
            this.closeDropdown();
        },
        onDropdownShow(event) {
            /* eslint-disable-next-line jquery/no-find */
            this.$options.slider = new Slider($(event.target).find('[data-realty-slider]'), {
                start: this.values.min,
                initialStart: this.value.min,
                end: this.values.max,
                initialEnd: this.value.max,
                step: this.values.step,
            });
        },
        onDropdownHide() {
            this.dirty = true;

            this.$emit('input', {
                min: Number(this.$options.slider.$input.val()),
                max: Number(this.$options.slider.$input2.val()),
            });

            this.closeDropdown();
        },
        onDropdownClose() {
            if (this.$options.slider) {
                this.$options.slider._destroy();
            }
        },
    },
};
